<template>
  <v-container fluid v-if="show">
    <v-dialog v-model="show" max-width="400px" v-if="bug">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;">
            <v-icon style="font-size: 18px;" color="white" class="mr-2">bug_report</v-icon>
            {{ $t(title) }}
          </span>
        </v-card-title>
        <v-card-subtitle class="secondary py-2 white--text d-flex align-center justify-space-between">
          <span class="subheader-font body-2">{{ $t(subtitle) }}</span>
        </v-card-subtitle>
        <v-card-text class="mt-5">
          <v-container class="pt-0">
            <v-form name="form" ref="formRef" @submit.prevent="onSaveClick">
              <v-row>
                <v-col cols="12" class="pt-0 px-0 d-flex flex-column">
                  <p class="body-1 font-weight-bold primary--text pb-1 mb-0">{{$t("bugReport.about")}}</p>
                  <div class="d-flex align-center">
                    <img
                      v-if="bug.categoryId === 20"
                      :src="
                        'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/' + bug.componentId + '.png'
                      "
                      :height="40"
                      contain
                      @error="onImageLoadFailure($event,'player')"
                    />
                    <img
                      v-if="bug.categoryId === 21"
                      :src="
                        'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + bug.componentId + '.png'
                      "
                      :height="30"
                      contain
                      @error="onImageLoadFailure($event,'team')"
                    />
                    <v-icon color="grey darken-1" v-if="bug.categoryId === 6">event</v-icon>
                    <span class="font-weight-medium ml-2 primary--text text-h6">{{bug.componentName}}</span>
                  </div>
                </v-col>
                <v-col cols="12" class="pa-0 mt-3">
                  <p class="body-1 font-weight-bold primary--text pb-1 mb-0">{{$t("general.comments")}}</p>
                  <v-textarea
                    hide-details
                    outlined
                    v-model="bug.comment"
                    :rules="commentRules"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end pr-6 pb-4">
          <v-btn :color="$vuetify.theme.dark ? 'white' : 'secondary'" rounded outlined class="elevation-0 monospace-font px-4" @click="show = false">{{$t('general.cancel')}}</v-btn>
          <v-btn
            rounded class="elevation-0 monospace-font white--text px-4" color="primary"
            @click="onSaveClick()"
          >{{$t('general.notify')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Dictionary from "../../dictionary";
import * as _ from "lodash";
import * as moment from "moment";

export default {
  name: "BugFormModal",
  components: {},
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage(){
      return this.$store.getters['auth/language'];
    }
  },
  filters: {
  },
  props: {
    title: {
      type: String,
      default: "general.notifyError"
    },
    subtitle: {
      type: String,
      default: "bugReport.modalSubtitle"
    }
  },
  data() {
    return {
      bug: null,
      show: false,
      validated: false,
      commentRules: [
        v =>
          v != null ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"]
      ]
    };
  },
  created() {},
  methods: {
    open(bug = {}) {
      this.bug = bug;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async onSaveClick() {
      if (this.$refs.formRef.validate()) {
        this.$emit("save", this.bug);
        this.bug = null;
      }
    },
    onImageLoadFailure(event, type) {
      if (type === "league" || type === "team") {
        event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
      } else if (type === "player") {
        event.target.src =
          "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png";
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/BugFormModal.vue